import script from "./Add.vue?vue&type=script&lang=ts&setup=true"
export * from "./Add.vue?vue&type=script&lang=ts&setup=true"

import "./Add.vue?vue&type=style&index=0&id=51608cce&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51608cce"]])

export default __exports__